import React from 'react';
import { PropTypes } from 'prop-types';
import { useTranslation } from 'react-i18next';
import { theme } from '~/styles/theme';
import { Table, Image } from '~/components';
import * as S from './styles';

export default function TeamBlock({
  className,
  value,
  isLocal,
  bgImage,
  label,
  shield,
}) {
  const { t } = useTranslation();
  const columns = React.useMemo(
    () => [
      {
        Header: t('season'),
        accessor: 'season',
      },
      {
        Header: t('totalWinnings'),
        accessor: 'winMatches',
      },
      {
        Header: t('totalDraws'),
        accessor: 'tiedMatches',
      },
      {
        Header: t('totalDefeats'),
        accessor: 'lostMatches',
      },
      {
        Header: t('arbitratedMatches'),
        accessor: 'arbitratedMatches',
      },
    ],
    [t]
  );

  const tableStyles = isLocal
    ? {
        headerColor: theme.whiteWithMidOpacity,
        secondaryColor: theme.mainGreyOpacity,
        textColor: theme.dark,
        fullWidth: true,
      }
    : {
        headerColor: theme.dark4,
        primaryColor: theme.dark5Opacity,
        textColor: theme.white,
        fullWidth: true,
      };
  return (
    <>
      <S.Container className={className} isLocal={isLocal}>
        <S.ShieldBackground bgImage={bgImage} />
        <S.TeamLabel isLocal={isLocal}>
          <S.TeamLabelText isLocal={isLocal}>
            <span>{label}</span>
            {shield && <Image width={50} src={shield} />}
          </S.TeamLabelText>
        </S.TeamLabel>
        <S.TableContainer isLocal={isLocal}>
          <Table
            columns={columns}
            data={value.map(row => {
              return {
                ...row,
                season: `${row.seasonYearStart}/${row.seasonYearEnd}`,
              };
            })}
            styleOptions={tableStyles}
          />
        </S.TableContainer>
      </S.Container>
    </>
  );
}

TeamBlock.propTypes = {
  className: PropTypes.string,
  value: PropTypes.array,
  isLocal: PropTypes.bool,
  bgImage: PropTypes.string,
  label: PropTypes.string,
  shield: PropTypes.string,
};

TeamBlock.defaultProps = {
  className: null,
  value: [],
  isLocal: false,
  bgImage: null,
  label: null,
  shield: null,
};
